import { Box } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectQuotationForm } from "../../../redux/selector";
import { actions } from "../../../redux/slice";
import { QuotationFormValues } from "../../../types";
import BoxDimensionsPanel from "./BoxDimensionsPanel";
import BoxStructurePanel from "./BoxStructurePanel";
import FloorPanel from "./FloorPanel";
import QuotationFormPanel from "./QuotationFormPanel";
import SummaryMetrics from "./SummaryMetrics";
import TyingEquipmentPanel from "./TyingEquipmentPanel";
import Standard95Panel from "./Standard95Panel";
import { useStyles } from "./styles";

const Quotation = () => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const formValues = useSelector(selectQuotationForm);

  const updateField = (
    field: keyof QuotationFormValues,
    value: string | boolean
  ) => {
    dispatch(actions.updateQuotationFormField({ field, value }));
  };

  if (!formValues) {
    return null;
  }

  return (
    <Box className={styles.root}>
      <SummaryMetrics formValues={formValues} />
      <QuotationFormPanel formValues={formValues} />
      <BoxDimensionsPanel formValues={formValues} updateField={updateField} />
      <FloorPanel formValues={formValues} updateField={updateField} />
      <BoxStructurePanel />
      <TyingEquipmentPanel />
      <Standard95Panel />
    </Box>
  );
};

export default Quotation;
